import React from 'react';
import {
  Card,
  GrossValue,
  HiddenGrossValue,
  TitleContainer,
  ValueContainer,
  ValueTextContainer,
} from './StatisticCard.styles';
import { Text16Light, Text24Bold } from '../../utils/Text/Text.styles';
import { formatPrice } from '../../../utils/util';

const StatisticCard = ({ title, icon, value, gross, hideGross }) => {
  return (
    <Card>
      <TitleContainer>
        <Text16Light>{title}</Text16Light>
        {icon}
      </TitleContainer>
      <ValueContainer>
        {hideGross ? <HiddenGrossValue>0</HiddenGrossValue> : <GrossValue>${formatPrice(value)} Net</GrossValue>}
        <ValueTextContainer>
          <Text24Bold>{`$${formatPrice(hideGross ? value : gross)}`}</Text24Bold>
        </ValueTextContainer>
      </ValueContainer>
    </Card>
  );
};

export default StatisticCard;
